import React from 'react';
import './TakeawaySection.css';

const TakeawaySection = () => {
  return (
    <section id="takeaways" className="hero is-medium is-link">
        <div className="hero-body">          
          <div className="container">
            <p className="title">
                An Enriching Diversity of Opinions            
              </p>
              <p className="mb-6 subtitle">
                Main Takeaways from the Workshops
              </p>
            <div className="columns is-centered">
                <div className="column is-vcentered">
                    <p className="heading">#1</p>
                    <p className="title is-5">Soil health is understood differently across all case studies</p>                    
                </div>
                <div className="column is-vcentered">
                    <p className="heading">#2</p>
                    <p className="title is-5">Land stewards (farmers, foresters, urban gardeners, etc.) lack support from other sectors</p>
                    <p className=""></p>
                </div>
                <div className="column is-vcentered">
                    <p className="heading">#3</p>
                    <p className="title is-5">Urban and forest soils lack focus and should gain more support</p>
                    <p className=""></p>
                </div>
                <div className="column is-vcentered">
                    <p className="heading">#4</p>
                    <p className="title is-5">Soil biodiversity needs more attention and we should have more accessible research outputs</p>
                    <p className=""></p>
                </div>
                <div className="column is-vcentered">
                    <p className="heading">#5</p>
                    <p className="title is-5">Soil health challenges are systemic issues</p>
                    <p className=""></p>
                </div>
            </div>
          </div>
        </div>
      </section>
  );
};

export default TakeawaySection;
